import React, { useEffect } from "react";
import { Landing } from "./pages/Landing";
import { initMetaPixel } from "./utils/metaPixel";
const TITLE = "Customer Service Team Training | 10 Sessions + 5 Bonuses";
const DESCRIPTION = "Ten ready-to-run, 30-minute facilitator-led sessions for difficult customer conversations, plus five bonus resources. English-language PDFs for customer service supervisors and trainers. $27 USD, one-time payment.";
export function App() {
  useEffect(() => {
    document.title = TITLE;
    document.documentElement.lang = "en";
    const metas: [string, string, string][] = [["name", "description", DESCRIPTION], ["property", "og:title", TITLE], ["property", "og:description", DESCRIPTION], ["name", "twitter:title", TITLE], ["name", "twitter:description", DESCRIPTION]];
    metas.forEach(([attribute, key, value]) => {
      let meta = document.querySelector(`meta[${attribute}="${key}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, key);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", value);
    });
    document.querySelectorAll('link[rel="canonical"], meta[property="og:url"]').forEach(el => el.remove());
    initMetaPixel();
  }, []);
  return <Landing data-id="element-0" data-mp="6hq1ea16ddl" />;
}